/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OAuthClient } from './OAuthClient';
import {
    OAuthClientFromJSON,
    OAuthClientFromJSONTyped,
    OAuthClientToJSON,
    OAuthClientToJSONTyped,
} from './OAuthClient';

/**
 * 
 * @export
 * @interface CreateOauthClientResponse
 */
export interface CreateOauthClientResponse {
    /**
     * 
     * @type {OAuthClient}
     * @memberof CreateOauthClientResponse
     */
    data: OAuthClient;
}

/**
 * Check if a given object implements the CreateOauthClientResponse interface.
 */
export function instanceOfCreateOauthClientResponse(value: object): value is CreateOauthClientResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateOauthClientResponseFromJSON(json: any): CreateOauthClientResponse {
    return CreateOauthClientResponseFromJSONTyped(json, false);
}

export function CreateOauthClientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOauthClientResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': OAuthClientFromJSON(json['data']),
    };
}

  export function CreateOauthClientResponseToJSON(json: any): CreateOauthClientResponse {
      return CreateOauthClientResponseToJSONTyped(json, false);
  }

  export function CreateOauthClientResponseToJSONTyped(value?: CreateOauthClientResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': OAuthClientToJSON(value['data']),
    };
}

